<template>
  <div class="login-container min-container">
    <div class="login-wrap">
      <div class="pg"></div>
      <div class="login-main">
        <div>
          <p class="login-title">考试阅卷系统</p>
          <div class="login-item">
            <login-phone @success="handleLoginNext"></login-phone>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginPhone from '@/components/Login/LoginPhone'
import { loginEvent } from '@/utils/sensor'

export default {
  components: {
    LoginPhone
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async handleLoginNext(userInfo) {
      localStorage.examId = ''
      this.$store.commit('HAS_TOKEN', true)
      this.$store.commit('SET_USER', userInfo)
      localStorage.setItem('user_id', userInfo.id)
      loginEvent(userInfo)
      this.$message.success('登录成功')
      this.$router.push({ name: 'judgeSelect' })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  background: #fafafa;
  .login-wrap {
    position: relative;
    margin: 100px auto;
    display: flex;
    width: 1160px;
    height: 600px;
    border-radius: 8px;
    box-shadow: 0 10px 36px 0 rgba(48, 111, 255, 0.15);
    overflow: hidden;
  }
  .pg {
    width: 520px;
    height: 600px;
    background: url("~@/assets/images/login/login-bg-judge.png") no-repeat
      center / cover;
    box-shadow: 4px 4px 12px 0 rgba(48, 111, 255, 0.4);
  }
  .login-main {
    position: relative;
    background: #fff;
    flex: 1;
    border-radius: 0 8px 8px 0;
  }
  .login-title {
    text-align: center;
    margin: 127px auto 20px;
    color: $titleColor;
    font-size: 24px;
    font-weight: 500;
  }
  .login-item {
    margin: auto;
    width: 416px;
  }
}
</style>
